import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Statute } from './statute.interface';
import { StatuteService } from './statute.service';

const service = new StatuteService();

export interface StatuteState {
   statutes: Array<Statute>;
}

const StatuteStore: Module<StatuteState, StoreState> = {
   namespaced: true,
   state: {
      statutes: [],
   },
   getters: {
      statutes: (state) => state.statutes,
   },
   mutations: {
      SET_STATUTES(state, statutes: Array<Statute>) {
         state.statutes = statutes;
      },
   },
   actions: {
      async getStatutes(context) {
         const response = await service.getStatutes();
         context.commit('SET_STATUTES', response.data);
         return response.data;
      },
   },
};

export default StatuteStore;
